<template>
  <div class="animated fadeIn">
    <b-card v-if="!partner && model && model.id">
      <h5 block>
      {{model.permissions || '-'}}
      파트너 : {{model.username || '-'}}
      <span class="pull-right">
        {{model.nickname || '-'}}
      </span>
      </h5>
    </b-card>
    <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" v-model="index">
      <b-tab :title="partner || (model && model.id) ? '파트너' : '파트너 생성'" border-variant="primary" >
        <div class="d-flex flex-wrap align-items-center">
          <div class="title mr-auto">
            파트너 정보
          </div>
          <div class="mb7">
            <span class="pull-right" v-if="!add && model.created_at">가입일  : {{model.created_at | datetime}}</span>
          </div>
        </div>
        <hr>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label label="Allow login" label-for="ph_use" v-b-tooltip.hover title="Allow login.">
              로그인 허용
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_alive" :disabled="lock" />
              <div class="checkbox-animate">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-col>
          <b-col class="col-xl-2 col-md-12  d-flex align-self-center">
            <label class="col-form-label" for="ph_group" v-b-tooltip.hover title="Permission.">권한</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12">
            <v-select :disabled="model && !model.parent_id" v-if="!lock" label="text" v-model="model.permissions" :options="codes.permissions_partner"></v-select>
            <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.id">
            <label class="col-form-label">마지막 접속일</label>
          </b-col>
          <b-col class="col-xl-10 col-md-12  d-flex align-self-center" v-if="model.id">
              {{model.last_visit | datetime}} @ {{model.last_addr}}
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-else>
            <label class="col-form-label" v-if="model && !model.parent_id">
              파트너 그룹 연결
              <small>생성 중인 파트너가 다른 파트너와 동일한 그룹에 속하는 경우</small>
            </label>
            <label class="col-form-label" v-else>파트너 그룹 : {{model.parent_username}}</label>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="!model.id">
            <b-button class="btn btn-sm margin_t col-md-12 mr-2" variant="primary" @click="partner_connect_modal = true" block>Search</b-button>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.parent_id && model.parent_id != model.id && lock">
            <label class="col-form-label" for="">파트너 그룹 소유자</label>
          </b-col>
          <b-col class="col-xl-10 col-md-12  d-flex align-self-center" v-if="model.parent_id && model.parent_id != model.id && lock">
            <label>{{model.parent_username}}</label>
            <b-button v-show="!(model.parent_id && model.parent_id == model.id)" variant="primary" @click="reload" block>View</b-button>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_username" v-b-tooltip.hover title="Username">
              사용자명(ID)
              <span class="text-danger ml-1">*</span>
              <span v-if="model.is_del" class="text-danger">Deleted user, Logging in is not possible even if you allow it.</span>
              <b-badge v-if="model && model.id && model.parent_id"  :variant="model.parent_id && model.parent_id == model.id ? 'success' : 'primary'">
                * 파트너 그룹 {{model.parent_id && model.parent_id == model.id ? ' Master' : 'Member'}}
              </b-badge>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
            <b-form-input :disabled="!add || lock" type="text" id="ph_username" v-model="model.username" :plaintext="lock" ></b-form-input>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_nickname">
              이름
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
            <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-2" v-show="add || !lock">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_pass">
              {{add ? '사용자' : '새'}} 비밀번호
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12">
            <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
            <b-badge v-if="model.new_password"  :variant="password_policy('number') ? '성공' : '위험'"> 번호 </b-badge>
            <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? '성공' : '위험'"> 대문자 </b-badge>
            <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? '성공' : '위험'"> 소문자 </b-badge>
            <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? '성공' : '위험'"> 특수문자 </b-badge>
            <b-badge v-if="model.new_password"  :variant="password_policy('length') ? '성공' : '위험'">
              최소 길이 : 10글자
            </b-badge>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.new_password">
            <label class="col-form-label" for="ph_pass2">
              비밀번호 확인
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12" v-if="model.new_password">
            <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" label="Invoice Email Notice" v-b-tooltip.hover title="Sets whether issued invoice is sent or not. Only 'Owner' accounts can be set.">
              이메일 청구 알림
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="Invoice_Email_Notice" :disabled="lock || model.parent_id && model.parent_id != model.id" v-model="model.allow_invoice" />
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_tax">세금 : [%]</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <b-form-input type="number" id="ph_tax" v-model="model.tax" :plaintext="lock"></b-form-input>
          </b-col>
        </b-row>
        <br>
        <div class="d-flex flex-wrap align-items-center">
          <div class="title_sub">
            지역
          </div>
        </div>
        <hr>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_country_group" v-b-tooltip.hover title="country">
              국가
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12">
            <v-select :readonly="true" :disabled="lock" label="name" v-model="region.country" :options="codes.country" ></v-select>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_language_group" v-b-tooltip.hover title="language">
              언어
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12">
            <v-select :readonly="true" label="name" :disabled="lock" v-model="region.language" :options="codes.language"></v-select>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_timezone_group" v-b-tooltip.hover title="Timezone">
              시간대
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12">
            <v-select :readonly="true" label="name" :disabled="lock" v-model="region.timezone" :options="codes.timezone" ></v-select>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_address" v-b-tooltip.hover title="Address for billing">
              주소
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12">
            <b-form-input type="text" id="ph_address" v-model="model.address" :plaintext="lock"></b-form-input>
          </b-col>
        </b-row>
        <hr>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_group" v-b-tooltip.hover title="Enter a single IP or network range, etc) 192.168.0.100, 192.168.0.0/24 ">
              허용된 IP들 목록
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex  flex-wrap align-self-center">
            <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="">
              <span class="text-danger ml-1">*</span>
              청구할때 로고를 사용합니다.
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <img v-if="lock" class="text-center" height="120" width="330" :src="model.logo || 'img/F1-uwss.png'" alt="Hello, F1security">
            <b-form-group v-else>
              <!-- v-show="!confirm_save && !confirm_refresh" -->
              <picture-input
                :z-index="2"
                radius="3"
                :prefill="model.logo"

                ref="pictureInput"
                height="140" min-height="150" width="600"  max-width="600" max-height="200"
                accept="image/*" size="2" button-class="btn btn-dark"
                :custom-strings="{
                  upload: '<h1>uploading</h1>',
                  drag: '<small>Drag & Drop<small>',
                }"
                @change="logo_change">
              </picture-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
      </b-tab>
    </b-tabs>
    <router-view></router-view>
  </div>
</template>

<style>
.g {
  /* width: 33px; */
  height: 100%;
}

/* .nav-tabs .nav-link{
  border-color : #c8ced3
} */
</style>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>